import { useEffect } from 'react';

// Zet de titel van het browsertabblad — voorheen stond overal exact dezelfde
// statische titel uit public/index.html ("FlexiTimeBooking"), waardoor
// bladwijzers voor de app, de boekingspagina en het admin-paneel onmogelijk
// van elkaar te onderscheiden waren. Zet de titel terug naar de standaard
// zodra de pagina verlaten wordt (bv. na uitloggen), niet enkel bij een
// volgende expliciete useDocumentTitle-aanroep.
export default function useDocumentTitle(title) {
    useEffect(() => {
        if (!title) return;
        const previous = document.title;
        document.title = title;
        return () => {
            document.title = previous;
        };
    }, [title]);
}
